var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.examLoading,
          expression: "examLoading",
        },
      ],
      staticClass: "ds-exam-page ds-input-style",
    },
    [
      _c("el-header", [_vm._t("header")], 2),
      _vm.notData
        ? _c("el-container", [
            _c("div", { staticClass: "no-data" }, [
              _vm._v(_vm._s(_vm.notData)),
            ]),
          ])
        : _c(
            "el-container",
            [
              _c(
                "el-aside",
                { attrs: { width: "315px" } },
                [
                  _c(
                    "DsfVirtualScroll",
                    { staticClass: "virtual-height" },
                    [_vm._t("left")],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-main",
                [
                  _c(
                    "DsfVirtualScroll",
                    { staticClass: "virtual-height" },
                    [_vm._t("main")],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-aside",
                {
                  staticStyle: { position: "relative" },
                  attrs: { width: "250px" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "aside-right" },
                    [_vm._t("right")],
                    2
                  ),
                ]
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }